import React from "react";

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import Autocomplete from "@mui/material/Autocomplete";
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useDispatch, useSelector } from "react-redux";
import Switch from '@mui/material/Switch';
import { getWhsById, resetWhsNavigation } from "../../reducers/whsReducer";
import { useParams } from "react-router-dom";
import useRudderStackAnalytics from "../../config/useRudderAnalytics";
export default function WHSEditReport(){
    const useRudderAnalytics=useRudderStackAnalytics();
    const {whsId, id}=useParams();
    const currForm=useSelector(state=>state.whs.entities.currWhs);
    const driverId=useSelector(state=>state.driver.entities.currDriver?.driverId);
    const driverJobTitle=useSelector(state=>state.driver.entities.currDriver?.driverJobTitle);
    const vehicle=useSelector(state=>state.vehicle.entities.vehicleList);
    const [loaded, setLoaded] = React.useState(false);
    const [formData, setFormData]=React.useState({
       date:dayjs(),
       site: "",
       driver: "",
       driverId:"",
       vehicle:"",
       deliveryDate:dayjs(),
       odometer:"",
       serviceDueKm:"",
       visualInspection:false,
       visualInspectionComment:"",
       interiorClean:false,
       exteriorClean:false,
       cleanlinessComment:"",
       firstAid:false,
       version:"v1",
        company:"thefruitbox"
    });
    const dispatch=useDispatch();
    
    const [vehicleInputValue, setVehicleInputValue] = React.useState('');
    // const vehicleElements=vehicle && vehicle.length>0?vehicle.map((e,i)=><MenuItem sx={{fontSize:"0.8rem"}} value={e.license}>{e.license}</MenuItem>):<MenuItem value={""}>No Vehicle Available</MenuItem>
    const handleToggleChange=async (e)=>{
        const {checked, name}=e.target;
        setFormData(prev=>{
                return {
                    ...prev,
                    [name]:checked
                }
            })
    }
    const handleChange=async (e)=>{
        if (e.$d){
            setFormData(prev=>{
                return {
                    ...prev,
                    deliveryDate:dayjs(dayjs(e.$d).format("YYYY-MM-DDTHH:mm:ssZ").toString())
                }
            })
        }
        else{
            const {name, value}=e.target
            setFormData(prev=>{
                return {
                    ...prev,
                    [name]: value                    
                }
            })
            
        }
    }
    React.useEffect(()=>{
        const resetState=async()=>{
            dispatch(getWhsById({whsId, driverId:id}))
            dispatch(resetWhsNavigation());
        }
        resetState()
    },[dispatch, whsId, id])
    React.useEffect(()=>{
       if (currForm && currForm.driver && !loaded) {
            setFormData({
                ...currForm,
                deliveryDate:dayjs(currForm.deliveryDate),
                departureTime:dayjs(currForm.departureTime)
            });
        setLoaded(true);
        }
    }, [currForm, loaded])
    React.useEffect(()=>{
        if(useRudderAnalytics && driverId){
            useRudderAnalytics.page("Edit Vehicle Inspect")
        }
    },[useRudderAnalytics, driverId])
    const element=driverId && !driverJobTitle.toLowerCase().includes("contractor")?           
     <form className="reportForm">
                <div className="reportField">
                    <h3>Instruction</h3>
                </div>
                <p className="reportField">Complete this form every Monday of the week and return to the Fleet Manager/Supervisor in your state<br/><span style={{fontSize:"0.8rem"}}>The Fleet Manager/Supervisor will investigate any issues that arise.</span></p>
                <div className="reportFieldBackground">
                <FormControl className="reportField">
                    <TextField value={formData.site} name="site" onChange={handleChange} disabled label="Site:" variant="outlined" />
                </FormControl>
                </div>
                <div className="reportField">
                    <h3>Operator Details</h3>
                </div>
                <div className="reportFieldBackground">
                <FormControl className="reportField">
                    <TextField  disabled value={formData.driver} name="driver" onChange={handleChange} label="Operator:" variant="outlined" />
                </FormControl>
                <FormControl className="reportField">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker', 'DatePicker']}>
                        <DatePicker
                            name="deliveryDate"
                            label="Date:"
                            value={formData.deliveryDate}
                            onChange={handleChange}
                            format="DD/MM/YYYY"
                            disabled
                            required
                        />
                    </DemoContainer>
                </LocalizationProvider>
                </FormControl>
                </div>
                <div className="reportField">
                    <h3>Vehicle Detail</h3>
                </div>
                <div className="reportFieldBackground">
            <FormControl className="reportField">
            <Autocomplete
                    value={formData.vehicle}
                    onChange={(e,v)=>{
                        setFormData(prev=>{
                            return {
                                ...prev,
                                vehicle:v
                            }
                        })
                    }}
                    inputValue={vehicleInputValue}
                    onInputChange={(event, newVehicleInputValue) => {
                    setVehicleInputValue(newVehicleInputValue);
                    }}
                    id="vehicle"
                    name="vehicle"
                    disabled
                    options={vehicle?[...vehicle].map((e)=>e.license):[]}
                    renderInput={(params) => <TextField required {...params} label="Registration Number:" />}
                />
            </FormControl>
                <FormControl className="reportField">
                    <TextField  disabled value={formData.odometer} name="odometer" type="number" required onChange={handleChange} label="Vehicle Odometer Reading:" variant="outlined" />
                </FormControl>
                <FormControl className="reportField">
                    <TextField  disabled value={formData.serviceDueKm} name="serviceDueKm" type="number" required onChange={handleChange} label="Service Due Km:" variant="outlined" />
                </FormControl>
                </div>
                <div className="reportField">
                    <h3>Visual Inpection</h3>
                </div>
                <div className="reportFieldBackground">
                <div className="reportField">
                    <InputLabel>Visual Inspection</InputLabel>
                    <FormControlLabel
                    control={<ButtonSwitch  disabled onChange={handleToggleChange} name="visualInspection" checked={formData.visualInspection}/>}
                />
                </div>
                <FormControl className="reportField">
                    <TextField  disabled value={formData.visualInspectionComment} name="visualInspectionComment" type="text" onChange={handleChange} label="Visual Inspection Comments:" variant="outlined" />
                </FormControl>
                </div>
                <div className="reportField">
                    <h3>Cleanliness/Tidiness</h3>
                </div>
                <div className="reportFieldBackground">
                     <div className="reportField">
                    <InputLabel>Interior Clean?</InputLabel>
                    <FormControlLabel
                    control={<ButtonSwitch  disabled onChange={handleToggleChange} name="interiorClean" checked={formData.interiorClean}/>}
                />
                </div>
                 <div className="reportField">
                    <InputLabel>Exterior Clean?</InputLabel>
                    <FormControlLabel
                    control={<ButtonSwitch  disabled onChange={handleToggleChange} name="exteriorClean" checked={formData.exteriorClean}/>}
                />
                </div>
                <FormControl className="reportField">
                    <TextField  disabled value={formData.cleanlinessComment} name="cleanlinessComment" type="text" onChange={handleChange} label="Cleanliness Comments:" variant="outlined" />
                </FormControl>
                </div>
                <div className="reportField">
                    <h3>First Aid</h3>
                </div>
                <div className="reportFieldBackground">
                    
                <div className="reportField">
                    <InputLabel>Are you able to locate the First Aid Kit?</InputLabel>
                    <FormControlLabel
                    control={<ButtonSwitch  disabled onChange={handleToggleChange} name="firstAid" checked={formData.firstAid}/>}
                />
                </div>
                
                </div>
            </form>:<></>
    return (
        <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
            {element}
        </div>
    )
}
const ButtonSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&::before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&::after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));